import React, {useState, useEffect} from 'react'
import { CNavbar, CNavLink, CNavbarNav, CNavbarBrand,
        CCollapse, CForm, CFormInput, CButton, CToggler,
        CInputGroup, CInput, CInputGroupText, CInputGroupAppend,
} from 'compat/coreui';
import { useNavigate } from 'react-router-dom';

export default function Search(props) {
    const [pin, setPin]=useState('');
    const [business, setBusiness]=useState('');
    const navigate = useNavigate()

    const searchHandler = (e) => {
      e.preventDefault()
      const params = {
        pincode:pin,
        sr: business,
      }
      console.log('params from search', params)
      navigate("/search", { state: params })
    }


    return (
        <React.Fragment>
            {/* <CFormInput type="text" placeholder="New Delhi, DL" name="pin" onChange={(e) => setPin(e.target.value)}/> */}
            <CForm inline onSubmit={(e) => {searchHandler(e)}} >
              <CInputGroup style={{width: 'max-content'}}>
              <CFormInput
                placeholder="Search by Business, strain, etc ...."
                className="mr-0 p-4"
                size="sm"
                type="text"
                name="business"
                onChange={(e) => setBusiness(e.target.value)}
              />
                <CInputGroupAppend style={{cursor: 'pointer'}} onClick={(e) => {searchHandler(e)}}>
                    <CInputGroupText className={'bg-success text-white'}>
                      Search
                    </CInputGroupText>
                </CInputGroupAppend>
              </CInputGroup>
            </CForm>
        </React.Fragment>
    )
}